import React from "react";
import "./section3.css";
import Marquee from "react-fast-marquee";

const cards = [
  {
    key: 6,
    name: "React Native",
    src: "/images/react.png",
  },
  {
    key: 5,
    name: "Redux",
    src: "/images/redux.png",
  },
  {
    key: 22,
    name: "React JS",
    src: "/images/react.png",
  },
  {
    key: 62,
    name: "Next JS",
    src: "/images/nextjs.png",
  },
  {
    key: 2,
    name: "Angular",
    src: "/images/angular.png",
  },
  {
    key: 15,
    name: "Mobx",
    src: "/images/mobx.png",
  },
  {
    key: 3,
    name: "Nodejs",
    src: "/images/node.png",
  },
  {
    key: 4,
    name: "MongoDB",
    src: "/images/mongodb.png",
  },

  {
    key: 7,
    name: "Cordova",
    src: "/images/cordova.png",
  },
  {
    key: 8,
    name: "Electronjs",
    src: "/images/electron.png",
  },
  {
    key: 9,
    name: "Javascript",
    src: "/images/js.png",
  },
  {
    key: 10,
    name: "Html",
    src: "/images/html.png",
  },
  {
    key: 11,
    name: "CSS",
    src: "/images/css.png",
  },
  {
    key: 12,
    name: "Adobe After Effects",
    src: "/images/ae.png",
  },
  {
    key: 13,
    name: "Adobe Photoshop",
    src: "/images/ps.png",
  },
  {
    key: 14,
    name: "Figma",
    src: "/images/figma.png",
  },
];

export default function Section3() {
  return (
    <section className="mt-5 pt-1 mb-md-4">
      <div className="container">
        <div className="row align-items-center">
          <div className="col d-flex justify-content-between align-items-center">
            <div className="section-header">
              <h1 className="font-weight-bold mb-0 display-md-3 display-3">
                Unveiling My Arsenal of Technologies
              </h1>
              <div data-aos="fade-right" className="underline w-25"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-5 py-3">
        <Marquee autoFill speed={45}>
          {cards.map((c, i) => (
            <div key={c.key} className="mx-3">
              <img key={c.key} src={c.src} alt={c.name} width={140} />
              <p className="font-weight-medium text-center mt-0">{c.name}</p>
            </div>
          ))}
        </Marquee>
      </div>
      <div
        className="p-md-5 py-5 px-4 d-flex align-items-center justify-content-center mt-5"
        style={{ backgroundColor: "#111111" }}
      >
        <img
          src="/images/eatSleepCode.jpg"
          alt="eat,sleep,code"
          className="d-md-block d-none w-50"
        />
        <img
          src="/images/eatSleepCode.jpg"
          alt="eat,sleep,code"
          className="d-md-none d-bloc w-100"
        />
      </div>
    </section>
  );
}
